var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useLanguage } from '@base/LanguageProvider';
import { TagType } from '@common/api';
import { shownInConfigurations } from '@data/exportConfiguration/exportConfiguration';
import { useExportConfigurations } from '@data/exportConfiguration/exportConfigurationActions';
import { useUpdateUserSettingsActions } from '@data/hooks/currentUser';
import { exportApi } from '@data/rest/api';
import { useBreadcrumbs } from '@data/viewmodels/breadcrumbs';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { FinderCreationWithAutocomplete } from '@shared/toolbar/FinderCreationWithAutocomplete';
import { downloadFile } from '@util/helpers';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import React from 'react';
import toast from 'react-hot-toast';
import { BsThreeDots } from 'react-icons/bs';
import { FaFileExcel, FaPlus } from 'react-icons/fa';
import { IoIosArrowDown, IoIosArrowForward, IoIosArrowUp } from 'react-icons/io';
import Manager from '@shared/modal/Manager';
import FSButton from '@components/FSButton';
import { FeatureWrapper } from '../../base/FeatureWrapper';
import Tags from '@shared/tags/Tags';
import { Search } from '@shared/icons/icons';
import { appColors } from '@styled/useTheme';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';
import { useLocalData } from '../../base/LocalDataContext';
export default function FinderToolbar(_a) {
    var _this = this;
    var _b, _c;
    var _d = _a.insertedFilterTags, insertedFilterTags = _d === void 0 ? [] : _d;
    var loadingInProgress = useBranch({
        loadingInProgress: ['state', 'loadingInProgress'],
    }).loadingInProgress;
    var L = useLanguage().L;
    var navigate = useNavigate();
    var _e = useAuth(), user = _e.user, userSettings = _e.settings;
    var toggleFinderExpanded = useUpdateUserSettingsActions().toggleFinderExpanded;
    var _f = useLocalData(), addFilterTagIds = _f.addFilterTagIds, removeFilterTagIds = _f.removeFilterTagIds;
    var _g = __read(React.useState(false), 2), dropdownOpen = _g[0], setDropdownOpen = _g[1];
    var _h = __read(React.useState('none'), 2), createMode = _h[0], setCreateMode = _h[1];
    var rf_reqInputs = React.useRef(null);
    var rf_export = React.useRef(null);
    var exportConfigurations = useExportConfigurations();
    var toggleDropdown = function (e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        setDropdownOpen(!dropdownOpen);
    };
    React.useEffect(function () {
        var handleBodyClick = function (e) {
            if (dropdownOpen && e.target.classList.value.lastIndexOf('no-close-req') === -1) {
                setDropdownOpen(false);
            }
        };
        window.addEventListener('click', handleBodyClick);
        return function () {
            //cleanup
            window.window.removeEventListener('click', handleBodyClick);
        };
    }, [dropdownOpen]);
    if (!user) {
        return null;
    }
    var itemClickHandler = function (path) {
        if (userSettings.finder_expanded === false) {
            toggleHierarchy();
        }
        navigate("/sheet/".concat(path));
    };
    var handleEmptyClick = function () {
        toggleFinderExpanded();
    };
    var toggleHierarchy = function (e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        toggleFinderExpanded();
    };
    var excelExport = function (id, name) {
        if (name === void 0) { name = 'export.xlsx'; }
        return __awaiter(_this, void 0, void 0, function () {
            var blob, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        toggleDropdown();
                        startGlobalLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, exportApi.exportExcel(id)];
                    case 2:
                        blob = _a.sent();
                        downloadFile(blob, name);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        toast.error('Failed to export from given configuration');
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        stopGlobalLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var showHelper = function (type, perm) {
        switch (type) {
            default:
            case 'req-inputs':
                if (perm) {
                    Manager.renderTitle('top', rf_reqInputs.current, 'Require inputs');
                }
                break;
            case 'export':
                if (perm) {
                    Manager.renderTitle('top', rf_export.current, 'Export to Excel file');
                }
                break;
        }
    };
    var appFinderToolbar = null;
    var startCreatingCluster = function () {
        setCreateMode('cluster');
    };
    var clusterOrFlowCreated = function () {
        setCreateMode('none');
    };
    return (React.createElement("div", { className: "finder-toolbar-wrapper", role: "toolbar" },
        React.createElement("div", { className: "finder-breadcrumbs" },
            React.createElement(BreadCrumbs, { toggleFinderExpanded: toggleFinderExpanded, itemClickHandler: itemClickHandler })),
        React.createElement("div", { className: "finder-breadcrumb-space", onClick: handleEmptyClick }),
        React.createElement(FeatureWrapper, { featureKey: "canSeeClusterFlowAdd" }, createMode !== 'none' && (React.createElement(FinderCreationWithAutocomplete, { onDone: clusterOrFlowCreated, mode: createMode, setCreateMode: setCreateMode }))),
        createMode === 'none' && (React.createElement("div", { className: "finder-actions center-children" },
            React.createElement("div", { className: "btn-group", style: { marginTop: 5, marginRight: 10, color: '#a3a3a3', fontSize: 16 } }, loadingInProgress ? L('Loading data...') : null),
            appFinderToolbar,
            React.createElement(Tags, { tags: insertedFilterTags, select: addFilterTagIds, remove: removeFilterTagIds, singleLine: true, filterByTypes: [TagType.Dimension], style: { marginRight: '16px' }, afterButtonLabel: L('Search'), customIcon: React.createElement(Search, { color: appColors.primary.w500, width: 22, height: 22 }), placeholder: " " }),
            React.createElement(FeatureWrapper, { featureKey: "canSeeClusterFlowAdd" },
                React.createElement("div", { className: "finder-actions_buttons" },
                    React.createElement(FSButton, { "$size": "small", "$type": "primary", title: L('New Row'), onClick: startCreatingCluster, icon: FaPlus }))),
            React.createElement("div", { className: "finder-dropdown" },
                React.createElement("button", { onClick: toggleDropdown, onMouseEnter: function () { return showHelper('dropdown', true); }, onMouseLeave: Manager.closePopover, className: "finder-button" },
                    React.createElement(FaFileExcel, null)),
                dropdownOpen && !!((_c = (_b = exportConfigurations === null || exportConfigurations === void 0 ? void 0 : exportConfigurations.data) === null || _b === void 0 ? void 0 : _b.filter(shownInConfigurations)) === null || _c === void 0 ? void 0 : _c.length) && (React.createElement("div", { className: "finder-dropdown-menu no-close-req" }, !exportConfigurations.data
                    ? 'Loading...'
                    : exportConfigurations.data
                        .filter(shownInConfigurations)
                        .map(function (ec) {
                        var _a;
                        return (React.createElement("div", { onClick: function (e) {
                                e.stopPropagation();
                            }, style: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                borderBottomWidth: 1,
                                padding: 2,
                            } },
                            React.createElement("p", { style: { fontSize: 12, textAlign: 'left', marginBottom: 0 } }, (_a = ec.name) !== null && _a !== void 0 ? _a : ''),
                            React.createElement(FSButton, { title: "Export", style: { width: 75 }, onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                e.stopPropagation();
                                                return [4 /*yield*/, excelExport(ec.id, ec.name + '.xlsx')];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } })));
                    })))),
            React.createElement("button", { className: "finder-toggle-column", onClick: toggleHierarchy }, userSettings.finder_expanded ? React.createElement(IoIosArrowUp, null) : React.createElement(IoIosArrowDown, null))))));
}
function BreadCrumbs(props) {
    var L = useLanguage().L;
    var breadcrumbs = useBreadcrumbs();
    var itemClickHandler = props.itemClickHandler, toggleFinderExpanded = props.toggleFinderExpanded;
    if (breadcrumbs.length === 0) {
        return (React.createElement("button", { key: "btn", onClick: function () {
                toggleFinderExpanded();
            } }, L('Select a row')));
    }
    var bcComponents = [];
    if (breadcrumbs.length > 4) {
        bcComponents.push(React.createElement("button", { key: 'st_' + 0, onClick: function () { return itemClickHandler(breadcrumbs[0].path); } }, breadcrumbs[0].label));
        bcComponents.push(React.createElement("div", { key: 'fi_three_dots', className: "finder-toolbar-cluster" },
            React.createElement(IoIosArrowForward, null),
            React.createElement(BsThreeDots, null),
            React.createElement(IoIosArrowForward, null)));
    }
    var _loop_1 = function (i) {
        bcComponents.push(React.createElement("div", { key: 'fi_' + i, className: "finder-toolbar-cluster" },
            React.createElement("button", { key: "st_".concat(i), onClick: function () { return itemClickHandler(breadcrumbs[i].path); } }, breadcrumbs[i].label),
            i !== breadcrumbs.length - 1 ? React.createElement(IoIosArrowForward, null) : null));
    };
    for (var i = Math.max(0, breadcrumbs.length - 4); i < breadcrumbs.length; i++) {
        _loop_1(i);
    }
    return React.createElement(React.Fragment, null, bcComponents);
}
